import type { ColorModePreference, ResolvedColorMode } from './colorModePreference';
import { resolveColorModePreference } from './colorModePreference';

type ApplyInitialColorModeOptions = {
    preference: ColorModePreference;
    systemColorMode: ResolvedColorMode;
    documentElement?: HTMLElement;
};

export const applyInitialColorMode = ({
    preference,
    systemColorMode,
    documentElement = document.documentElement
}: ApplyInitialColorModeOptions): ResolvedColorMode => {
    const resolvedColorMode = resolveColorModePreference(preference, systemColorMode);

    documentElement.dataset.colorMode = resolvedColorMode;
    documentElement.style.colorScheme = resolvedColorMode;

    return resolvedColorMode;
};
